// TODO: review and cleanup
import {error} from 'core/log';

/**
 * Services storage.
 *
 * {
 *  [name: String]: {
 *    type: String,
 *    config: String
 *  }
 * }
 */
const services = {};

/**
 * jQuery events "bus".
 */
const $pubsub = jQuery({});

/**
 * Dictionary of original -> context bound callbacks.
 * Powers custom callback scope binding, unique by event name.
 *
 * {
 *  [originalCallbackRef: Function]: {
 *    [eventName: String]: Function
 *  }
 * }
 */
const pubsubContext = {};

module.exports = {

  /**
   * Define a service call.
   *
   * @param {String} name   Unique identifier
   * @param {String} type   Type of the service. e.g. `ajax`
   * @param {Object} config Service configuration.
   *
   * @see http://api.jquery.com/jquery.ajax/ for supported config options
   */
  define: function (name, type, config) {
    services[name] = {type, config};
  },

  /**
   * Do service call.
   *
   * @param {String}          name              Unique service identifier
   * @param {Object|Function} paramsOrCallback  Service call params or callback.
   * @param {Function}        [callback]        Callback if service call params were passed.
   */
  request: function (name, paramsOrCallback, callback = undefined) {
    const service = services[name];

    if (!service) {
      error(`no service was defined with name ${name}`);
      return;
    }

    let config = jQuery.extend({}, service.config);

    if (typeof paramsOrCallback === 'function') {
      callback = paramsOrCallback;
    } else {
      config = jQuery.extend(config, {data: paramsOrCallback});

      const rurlData = /\{([^}]+)}/g;
      const mappedKeys = [];

      // mirror amplify functionality to replace {paramValue} in the defined url and later delete from params
      config.url = typeof config.url === 'string' && config.url.replace(rurlData, function (m, key) {
        if (key in config.data) {
          mappedKeys.push(key);
          return config.data[key];
        }
      });

      mappedKeys.forEach((key) => {
        delete config.data[key];
      });
    }

    if (typeof config.url !== 'string' || config.url.trim() === '') {
      error('invalid or empty url is specified for request', name, config.url);
      return;
    }

    jQuery.ajax(config).done(callback);
  },

  /**
   * Subscribe to event.
   *
   * *Note that subsequent subscribe calls of the same callback for the same event name
   * with different contexts are not supported, all subsequent calls are ignored.*
   *
   * @param {String}    name      Unique event identifier.
   * @param {Object}    context   Scope of the callback execution.
   * @param {Function}  callback  Function to be executed upon event publish.
   */
  subscribe: function (name, context, callback) {
    pubsubContext[callback] = pubsubContext[callback] || {};

    // do nothing if callback is already subscribed to a given event
    if (pubsubContext[callback][name]) {
      return;
    }

    pubsubContext[callback][name] = (event, ...rest) => callback.apply(context, rest);
    $pubsub.on(name, pubsubContext[callback][name]);
  },

  /**
   * Remove a subscription.
   *
   * @param {String}    name      The topic being unsubscribed from.
   * @param {Function}  callback  The callback that was originally subscribed.
   */
  unsubscribe: function (name, callback) {
    const cb = (pubsubContext[callback] || {})[name];

    if (cb) {
      $pubsub.off(name, cb);
      delete pubsubContext[callback][name];

      // remove original callback reference when no more bound callbacks left
      if (Object.keys(pubsubContext[callback]).length === 0) {
        delete pubsubContext[callback];
      }
    }
  },

  /**
   * Publish an event.
   *
   * @param {String} name   Unique event identifier.
   * @param {Object} [data] Data that needs to be passed to the callback handler.
   */
  publish: function (name, data = undefined) {
    // make sure to wrap array and array-like data into array to prevent jQuery from unwrapping original
    // data into a list of arguments (e.g. passing single jQuery element will pass DOM element reference
    // as data into the event handler callback instead of jQuery element)
    $pubsub.trigger(name, data instanceof jQuery || data instanceof Array ? [data] : data);
  }
};
